/*
 * The english translation of all compoinents that the Profile view folder needs.
 */
export const PROFILE_VIEW_EN = {
  // AppearanceLayout.vue
  colorPicker: 'Color Picker',
  primaryColor: 'Primary Color',
  backgroundColor: 'Background Color',
  // PromptDataTable.vue
  createPrompt: 'Create Prompt',
  // GamificationComponent.vue
  creations: 'Creations',
  languages: 'Languages',
  resetBoxLayout: 'Reset Box Layout',
  makeSureYouTypeInYourPassword: 'Make sure you type in your password',
  close: 'Close',
  saveChanges: 'Save Changes',
  yourOrganisation: 'Your Organisation: ',
  languageDescription: 'Language Description',
  enterLanguageDescription: 'Enter language description...',
  // UsageSection.vue
  usage: 'Usage',
  unlimited: 'unlimited',
  resetsOn: 'resets on {date}',
  noActiveLimits: 'No active usage limits',
  usageFetchFailed: 'Could not load usage',
  teamUsagePercent: 'team: {percent}%',
  teamUsageAmount: 'team: {count} / {limit}'
}
/*
 * The german translation of all compoinents that the Profile view folder needs.
 */
export const PROFILE_VIEW_DE = {
  // AppearanceLayout.vue
  colorPicker: 'Farbauswahl',
  primaryColor: 'Primärfarbe',
  backgroundColor: 'Hintergrundfarbe',
  // PromptDataTable.vue
  createPrompt: 'Prompt erstellen',
  // GamificationComponent.vue
  creations: 'Inhalte',
  languages: 'Sprachen',
  resetBoxLayout: 'Box Layout zurücksetzten',
  makeSureYouTypeInYourPassword: 'Tippen Sie Ihr Passwort ein',
  close: 'Schließen',
  saveChanges: 'Änderungen speichern',
  yourOrganisation: 'Ihre Organisation: ',
  languageDescription: 'Sprachbeschreibung',
  enterLanguageDescription: 'Sprachbeschreibung eingeben...',
  // UsageSection.vue
  usage: 'Nutzung',
  unlimited: 'unbegrenzt',
  resetsOn: 'zurückgesetzt am {date}',
  noActiveLimits: 'Keine aktiven Limits',
  usageFetchFailed: 'Nutzung konnte nicht geladen werden',
  teamUsagePercent: 'Team: {percent}%',
  teamUsageAmount: 'Team: {count} / {limit}'
}
